query PaginatedDeliverables($campaignId: ID!, $libraryFilters: InputLibraryFilters!, $page: Int, $perPage: Int) {
    computeDeliverables(
        campaignId: $campaignId
        libraryFilters: $libraryFilters
        page: $page
        perPage: $perPage
        preview: true
    ) {
        deliverables {
            _id
            computedValues {
                editableId
                name
                type
                value
                layer
                settings
            }
            editableGroupValueIds
            hash
            language
            masterTemplate {
                _id
            }
            metadata {
                _id
                field {
                    _id
                    name
                }
                value
            }
            publishedStatus
            status
            users {
                user {
                    id
                    role {
                        actions
                        name
                    }
                }
                status
            }
            visibleTo
            reportingLabel
        }
        pagination {
            page
            perPage
            maxPage
            total
            totalCount
        }
    }
}
